<template>
  <div>
    <v-row
      class="mt-5"
    >
      <v-col
        sm="12"
        md="12"
        lg="12"
        xl="6"
      >
        <section>
          <line-chart
            :raw-data="players"
            x-value="last_name"
            y-value-prefix="player_stats."
            :chart-value-keys="[{ key: 'TL', label: $t('variables.TL'), type: 'bar' }, { key: 'TG', label: 'RPE', type: 'line' }, { key: 'TTM', label: $t('variables.TTM'), type: 'line' }]"
            class="mb-5"
            :yaxis="[ { title: { text: $t('chart_legends.load')} }, { title: { text: 'RPE' }, opposite: true}, { title: { text: $t('variables.TTM')}, opposite: true}]"
            :markers="{colors: ['#00E396','#008FFB', '#FEB019']}"
            :xaxis="{
              labels: {
                rotate: -45
              },
              categories: players.map(p => p.first_name + ' ' + p.last_name),
              tickPlacement: 'between'
            }"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.main_team_indicators') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
      <v-col
        sm="12"
        md="12"
        lg="12"
        xl="6"
      >
        <section>
          <line-chart
            type="bar"
            :raw-data="enjoymentDistribution"
            x-value="key"
            :chart-value-keys="[{ key: 'value', label: $t('variables.ENJY'), type: 'bar' }]"
            :yaxis="[{ labels: {
              formatter: function(value) {
                return value.toFixed(2);
              }
            } }]"
            :colors="['#FF4560']"
            :xaxis="{
              labels: {
                rotate: -45
              },
              categories: enjoymentDistribution.map(p => p.key),
              tickPlacement: 'between',
              title: { text: $t('variables.ENJY')}
            }"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.enjoyment_distribution') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
      <v-col
        sm="12"
        md="12"
        lg="12"
        xl="6"
      >
        <section>
          <line-chart
            class="mb-5"
            :raw-data="players"
            :chart-value-keys="[ { key: 'UXPCSTD', type: 'bar', label: $t('variables.UXPCSTD') }, { key: 'UXPCSMYPM', label:$t('variables.UXPCSMYPM') } ]"
            :plot-options="{bar: {horizontal: false, borderRadius: 10}}"
            x-value="last_name"
            y-value-prefix="player_stats."
            :markers="{size: 5}"
            :yaxis="[ { title: { text: $t('variables.UXPCSTD') }, opposite: true}, { title: { text: $t('variables.UXPCSMYPM') } } ]"
            :xaxis="{
              labels: {
                rotate: -45
              },
              categories: players.map(p => p.first_name + ' ' + p.last_name),
              tickPlacement: 'between'
            }"
            :colors="[ '#FEB019', '#008FFB' ]"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t("card_title.total_distance_and_m_min") }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
      <v-col
        sm="12"
        md="12"
        lg="12"
        xl="6"
      >
        <section>
          <line-chart
            class="mb-5"
            :raw-data="players"
            :chart-value-keys="[ { key: 'CAPGCSDCB13EG2', type: 'bar', label: $t('chart_legends.deceleration_less_-4') },
                                 { key: 'UXDCB13', type: 'bar', label: $t('chart_legends.deceleration_less_-3') },
                                 { key: 'UXDCB14', type: 'bar', label: $t('chart_legends.deceleration_less_-2') },
                                 { key: 'UXACB58', type: 'bar', label: $t('chart_legends.accelerations_more_2') },
                                 { key: 'UXACB68', type: 'bar', label: $t('chart_legends.accelerations_more_3') },
                                 { key: 'CAPGCSACB13EG2', type: 'bar', label: $t('chart_legends.accelerations_more_4') }, ]"
            x-value="last_name"
            y-value-prefix="player_stats."
            :xaxis="{
              labels: {
                rotate: -45
              },
              categories: players.map(p => p.first_name + ' ' + p.last_name),
              tickPlacement: 'between'
            }"
            :colors="[ '#ff0000', '#ff6666', '#ff9999', '#1affb2', '#00e396', '#00b377']"
            :fill="{ opacity: [0.5, 0.5, 0.5, 0.5, 0.5, 0.5]}"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.accelerations_and_decelerations') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
      <v-col
        sm="12"
        md="12"
        lg="12"
        xl="6"
      >
        <section>
          <line-chart
            :raw-data="players"
            :chart-value-keys="[ { key: 'HRMAX', label: $t('hr_variables.max_heart_rate') }, { key: 'HRAVG', type: 'bar', label: $t('hr_variables.avg_heart_rate') } ]"
            x-value="last_name"
            y-value-prefix="player_stats."
            :yaxis="[ { title: { text: $t('hr_variables.hr_bpm') }, min: 0} ]"
            :xaxis="{
              labels: {
                rotate: -45
              },
              categories: players.map(p => p.first_name + ' ' + p.last_name),
              tickPlacement: 'between'
            }"
            :markers="{size: 4}"
            :colors="['#FF4560', '#df7595' ]"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.avg_max_heart_rate') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
      <v-col
        sm="12"
        md="12"
        lg="12"
        xl="6"
      >
        <section class="fill-height">
          <team-pain-widget
            :event-stats="team"
          />
        </section>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart'
import TeamPainWidget from '@/components/training-load/TeamPainWidget.vue'

export default {
  name: 'PerformanceSummaryGraphs',
  components: { TeamPainWidget, LineChart },
  props: {
    players: {
      type: Array,
      required: true
    },
    team: {
      type: [Object, Array],
      required: true
    }
  },
  data: () => ({
    labels: {}
  }),
  computed: {
    enjoymentDistribution() {
      if (!this.team.ENJY_dist) return []

      const data = [
        { key: 1, value: null },
        { key: 2, value: null },
        { key: 3, value: null },
        { key: 4, value: null },
        { key: 5, value: null }
      ]

      this.team.ENJY_dist.forEach((element) => {
        data.find(e => e.key === element.grade).value = element.value
      })

      return data
    }
  },
  created() {
    this.players.map(player => {
      if (!player.player_stats) return player
      player.player_stats.UXMAXVELALL = Math.round((player.player_stats?.CACGCSMXV / (player.player_stats?.UXMAXVELREF / 100)) * 100) / 100
      return player
    })
  }
}
</script>

<style scoped>

</style>
